import type {
  ExerciseTemplate,
  ExerciseTemplateDTO,
  DifficultyOption,
  DifficultyOptionDTO,
  DifficultyOptionLevelDTO,
  DifficultyOptionLevel,
  RoutineTemplateSimplifyDTO,
  RoutineTemplateSimplify,
} from "@akina/domain";

const routineSimplifyMapper = {
  toDomain: (routineSimplifyDto: RoutineTemplateSimplifyDTO | null): RoutineTemplateSimplify | null => {
    if (!routineSimplifyDto) return null;
    return {
      breakDuration: routineSimplifyDto.break_duration,
      laterality: routineSimplifyDto.laterality,
      nominalDuration: routineSimplifyDto.nominal_duration,
      nominalNumberRepetitions: routineSimplifyDto.nominal_number_repetitions,
      nSet: routineSimplifyDto.n_set,
      routineTemplateKey: routineSimplifyDto.routine_template_key,
    };
  },
  toDTO: (routineSimplify: RoutineTemplateSimplify | null): RoutineTemplateSimplifyDTO | null => {
    if (!routineSimplify) return null;
    return {
      break_duration: routineSimplify.breakDuration,
      laterality: routineSimplify.laterality,
      nominal_duration: routineSimplify.nominalDuration,
      nominal_number_repetitions: routineSimplify.nominalNumberRepetitions,
      n_set: routineSimplify.nSet,
      routine_template_key: routineSimplify.routineTemplateKey,
    };
  },
};
export const exerciseTemplateMapper = {
  toDomain: (exTemplateDto: ExerciseTemplateDTO): ExerciseTemplate => ({
    bodyParts: exTemplateDto.body_parts,
    displayedName: exTemplateDto.displayed_name,
    equipment: exTemplateDto.equipment,
    key: exTemplateDto.key,
    thumbnail: exTemplateDto.thumbnail,
    routineMetric: exTemplateDto.routine_metric,
    trainingTypes: exTemplateDto.training_types,
    defaultRoutineInformation: routineSimplifyMapper.toDomain(exTemplateDto.default_routine_information),
    previewGif: exTemplateDto.preview_gif,
    hasLaterality: exTemplateDto.has_laterality,
  }),
  toDTO: (exTemplate: ExerciseTemplate): ExerciseTemplateDTO => ({
    body_parts: exTemplate.bodyParts,
    displayed_name: exTemplate.displayedName,
    equipment: exTemplate.equipment,
    key: exTemplate.key,
    thumbnail: exTemplate.thumbnail,
    training_types: exTemplate.trainingTypes,
    routine_metric: exTemplate.routineMetric,
    default_routine_information: routineSimplifyMapper.toDTO(exTemplate.defaultRoutineInformation),
    preview_gif: exTemplate.previewGif,
    has_laterality: exTemplate.hasLaterality,
  }),
};

export const difficultyOptionsMapper = {
  toDomain: (option: DifficultyOptionDTO): DifficultyOption => ({
    easyLevel: difficultyOptionLevelMapper.toDomain(option.easy_level),
    mediumLevel: difficultyOptionLevelMapper.toDomain(option.medium_level),
    hardLevel: difficultyOptionLevelMapper.toDomain(option.hard_level),
  }),
  toDTO: (option: DifficultyOption): DifficultyOptionDTO => ({
    easy_level: difficultyOptionLevelMapper.toDTO(option?.easyLevel ?? null),
    medium_level: difficultyOptionLevelMapper.toDTO(option?.mediumLevel ?? null),
    hard_level: difficultyOptionLevelMapper.toDTO(option?.hardLevel ?? null),
  }),
};

const difficultyOptionLevelMapper = {
  toDomain: (option: DifficultyOptionLevelDTO | null): DifficultyOptionLevel | null => {
    if (!option) return null;
    return {
      exerciseTemplateKey: option.exercise_template_key,
      routineMetric: option.routine_metric,
      defaultRoutineInformation: routineSimplifyMapper.toDomain(option.default_routine_information),
    };
  },
  toDTO: (option: DifficultyOptionLevel | null): DifficultyOptionLevelDTO | null => {
    if (!option) return null;
    return {
      exercise_template_key: option.exerciseTemplateKey,
      routine_metric: option.routineMetric,
      default_routine_information: routineSimplifyMapper.toDTO(option.defaultRoutineInformation),
    };
  },
};
